module.exports = __webpack_public_path__ + "img/2019_10_1.053ce8a9.jpg";